"use client";

import Skeleton from "react-loading-skeleton";
import Price from "@/components/Price/price";
import { BodyText } from "@/components/BodyText";
import Badge from "@/components/Badge";
import ProductAttributes from "./product-attributes";
// import ProductCartBuyInquiry from "@/components/Product/product-cart-buy-inquiry";

import { Link } from "@/navigation";
// import ProductVariable from "@/components/Product/product-variable";
// import { useProductVariableStore } from "@/lib/store/product-variable.store";
// import { useProductAttributeStore } from "@/lib/store/product-attribute.store";
import { useLocale, useTranslations } from "next-intl";
import { useEffect, useRef, useState } from "react";
import { observeElementIntersection, productTranslationName } from "@/lib/utils/util";
import { debounce } from "@/lib/utils";
import { SocialShare } from "../SingleBlog/SocialShare";
import Rating from "react-rating";
import { useSelect } from "@react-three/drei";
import ProductCartBuyInquiry from "./product-cart-buy-inquiry";
import ProductInfo from "./ProductInfo";
import { defaultLocale } from "@/config";
import { Modal, Popconfirm } from "antd";
import { contactInfo } from "@/lib/contacts";
import { useModalInquiryContext } from "@/context/ModalInquiryContext";

type Props = {
	product: any | null;
};

export default function Information({ product }: Props) {
	let locale = useLocale();
	const [isClient, setIsClient] = useState(false);
	const [VariantActive, setVariantActive] = useState<any>(null);
	const [Variant, setVariant] = useState<any>(null);
	const [modal2Open, setModal2Open] = useState(false);
	const { setVariantActive3DName } = useModalInquiryContext();

	const t = useTranslations();
	const productSelectRef = useRef<HTMLDivElement | null>(null);
	// const { setSelectAttribute } = useProductAttributeStore();
	const handlerAttribute = (item: any) => {
		setVariantActive(item);
		setVariantActive3DName(item.name);
	};
	// const { currentProduct } = useProductVariableStore();

	useEffect(() => {
		setIsClient(true);
		// 优先使用选中的 variant，否则使用第一个
		if (product?.selectedVariant) {
			setVariant(product.selectedVariant);
			setVariantActive(product.selectedVariant);
		} else if (product?.variants?.length > 0) {
			setVariant(product.variants[0]);
			setVariantActive(product.variants[0]);
		}
	}, [product]);

	let isvariants = product?.variants?.some((item) => item.quantityAvailable > 0);
	const description: any = product?.description ? JSON.parse(product?.description) : null;
	const descriptionJson: any = product?.translation?.descriptionJson
		? JSON.parse(product?.translation?.descriptionJson)
		: null;

	if (!isClient) {
		return (
			<div className="min-h-[400px]">
				<Skeleton count={5} />
			</div>
		);
	}

	// console.log(VariantActive,'VariantActive');
	let productName =
		productTranslationName(product?.translation?.name) || productTranslationName(product?.name);

	return (
		<div className="relative w-full">
			<div id="product-select">
				{/* {product?.name ? (
					<h2 className="text-[26px]  font-medium text-black md:leading-10">{productName}</h2>
				) : (
					<>
						<Skeleton width={"100%"} height={40} />
						<Skeleton width={"100%"} height={40} />
					</>
				)}

				<div className="proSel-options">
					{product
						? description?.blocks[1]?.data?.text && (
								<>
									<div className="mt-5 w-full border border-themeSecondary200" />
									<BodyText
										innerHTML={descriptionJson?.blocks[1]?.data?.text || description?.blocks[1]?.data?.text}
										className="mt-5 text-base font-normal text-themeSecondary500"
									></BodyText>
									<div className="mt-5 w-full border border-themeSecondary200" />
								</>
							)
						: [0, 1, 2].map((i) => {
								return <Skeleton width={"100%"} height={30} className="mt-2" key={i} />;
							})}

					{product?.variants?.length > 0 && (
						<ProductAttributes options={product?.variants} changeValue={handlerAttribute} />
					)}
				</div> */}
				{/* 询盘按钮 */}
				<div className="mb-3">
					<ProductCartBuyInquiry {...product} product={product} VariantActive={VariantActive} />
				</div>

				{/* 分享按钮 */}
				<Share modal2Open={modal2Open} setModal2Open={setModal2Open} />
			</div>
		</div>
	);
}

function Share({ modal2Open, setModal2Open }) {
	const t = useTranslations('nav');

	return (
		<>
			<div className="flex gap-6 Information mt-5 items-center">
				<div className="text-md flex items-center gap-x-2">
					<i className="ri-share-line text-xl"></i> <span>{t('Share')}</span>
				</div>
				<div className="flex items-center">
					<SocialShare />
				</div>
			</div>
		</>
	);
}